import React from "react";

import { css } from "@emotion/css";
import {
  desktop,
  laptop,
  tablet,
} from "../../../styles/breakpoints";

import AnalyzingImg from "../../../img/png/tech/analyzing.png";
import Check1Img from "../../../img/svg/tech/check-1.svg";
import Check2Img from "../../../img/svg/tech/check-2.svg";
import Check3Img from "../../../img/svg/tech/check-3.svg";
import Check4Img from "../../../img/svg/tech/check-4.svg";
import Check5Img from "../../../img/svg/tech/check-5.svg";
import Check6Img from "../../../img/svg/tech/check-6.svg";
import { useI18n } from "../../../i18n";

const Scan = () => {
  const { t } = useI18n();
  return (
    <div className={style.container}>
      <video autoPlay loop muted playsInline webkit-playsinline>
        <source
          src="/videos/face_body_scan_for_technology_page.mp4"
          type="video/mp4"
        />
      </video>
      <div className="content">
        <div className="left">
          <h2>02</h2>
          <h4>{t("tech_scan")}</h4>
          <p>
            {t("tech_scan_body")}
          </p>
        </div>
        <div className="right">
          <img alt="" src={AnalyzingImg} className="analyze" />
          <div className="checks">
            <img alt="" src={Check1Img} />
            <img alt="" src={Check2Img} />
            <img alt="" src={Check3Img} />
            <img alt="" src={Check4Img} />
            <img alt="" src={Check5Img} />
            <img alt="" src={Check6Img} />
          </div>
        </div>
      </div>
    </div>
  );
};

const style = {
  container: css({
    width: "100%",
    height: 1110,
    position: "relative",

    video: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    ".content": {
      position: "absolute",
      bottom: 120,
      left: 0,
      right: 0,
      margin: "auto",
      zIndex: 1,
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "space-between",
      justifyContent: "space-between",
      alignItems: "center",
      maxWidth: 1200,

      ".left": {
        width: 448,
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "flex-start",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      },
      ".right": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 9.684,
        alignSelf: "stretch",
        justifyContent: "flex-end",
        maxWidth: 720,

        ".analyze": {
          maxHeight: "100px",
        },

        ".checks": {
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",
          gap: 12,
        },
      },
      h2: {
        color: "#6643FF",
        textAlign: "center",
        fontFamily: "Syne",
        fontSize: 170,
        fontStyle: "normal",
        fontWeight: 700,
        opacity: 0.3,
        mixBlendMode: "plus-darker",
        lineHeight: "159px",
        marginBottom: 0,
      },
      h4: {
        color: "#FFF",
        fontFamily: "Syne",
        fontSize: 60,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "60px",
        marginBottom: 24,
        maxWidth: 356,
      },
      p: {
        color: "#fff",
        fontFamily: "Inter",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        letterSpacing: 0.32,
        textAlign: "left",
      },
    },
    [desktop]: {
      height: 1024,

      ".content": {
        bottom: 88,
        zIndex: 1,
        maxWidth: 725,

        ".left": {
          width: 323,
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          alignContent: "flex-start",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        },
        ".right": {
          maxWidth: 335,
          alignItems: "flex-start",

          img: {
            height: "63px",
            width: "auto",
            marginLeft: -20,
          },

          ".checks": {
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: 12,

            img: {
              height: "33px",
              width: "auto",
              marginLeft: 0,
            },
          },
        },
        h2: {
          fontSize: 150,
          fontStyle: "normal",
          lineHeight: "159px",
        },
        h4: {
          fontSize: 48,
          lineHeight: "50px",
        },
        p: {
          fontSize: 14,
        },
      },
    },
    [laptop]: {
      height: 744,

      ".content": {
        bottom: 88,
        zIndex: 1,
        maxWidth: 755,
        paddingLeft: 20,
        paddingRight: 20,

        ".left": {
          width: 323,
        },
        ".right": {
          maxWidth: 335,
          alignItems: "flex-start",

          img: {
            height: "63px",
            width: "auto",
            marginLeft: -20,
          },

          ".checks": {
            alignItems: "flex-start",
            justifyContent: "flex-start",
            gap: 12,

            img: {
              height: "33px",
              width: "auto",
              marginLeft: 0,
            },
          },
        },
        h2: {
          fontSize: 170,
          lineHeight: "160px",
        },
        h4: {
          fontSize: 52,
          lineHeight: "50px",
          marginBottom: 18,
          maxWidth: 326,
        },
        p: {
          fontSize: 14,
        },
      },
    },
    [tablet]: {
      height: 1000,
      backgroundColor: "#000",

      video: {
        height: 724,
      },
      ".content": {
        bottom: 40,
        zIndex: 1,
        maxWidth: 755,
        paddingLeft: 20,
        paddingRight: 20,
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",

        ".left": {
          maxWidth: 334,
          width: "100%",
          margin: "auto",
          marginBottom: 80,
        },
        ".right": {
          maxWidth: 334,
          width: "100%",
          alignItems: "flex-start",
          margin: "auto",
          img: {
            marginLeft: 40,
          },
        },
        h2: {
          fontSize: 172,
          lineHeight: "160px",
        },
        h4: {
          fontSize: 42,
          lineHeight: "50px",
          maxWidth: 334,
        },
        p: {
          fontSize: 14,
          lineHeight: "20px",
        },
      },
    },
  }),
};

export default Scan;
